import { ENV } from '../constants/EnvHelp'

type EnvironmentDates = {
  prod: string
  staging?: string
  beta?: string
}

type TimeBasedFeatureConfig = {
  startDate: string | EnvironmentDates
  endDate: string | EnvironmentDates
}

const TIME_BASED_FEATURES_CONFIG: Record<string, TimeBasedFeatureConfig> = {
  blackFridayPromo: {
    startDate: {
      prod: '2025-11-18T00:00:00-05:00',
      staging: '2025-11-05T00:00:00-05:00',
    },
    endDate: '2025-12-02T23:59:59-05:00',
  },
  referral100Reward: {
    startDate: {
      prod: '2026-02-09T00:00:00-05:00',
      staging: '2026-02-04T00:00:00-05:00',
    },
    endDate: '2026-03-08T00:00:00-05:00',
  },
}

const TIME_BASED_FEATURES = TIME_BASED_FEATURES_CONFIG as {
  blackFridayPromo: TimeBasedFeatureConfig
  referral100Reward: TimeBasedFeatureConfig
}

export type TimeBasedFeatureKey = keyof typeof TIME_BASED_FEATURES

function resolveDate(date: string | EnvironmentDates): Date {
  if (typeof date === 'string') {
    return new Date(date)
  }

  if (ENV.isStaging && date.staging) {
    return new Date(date.staging)
  }

  if (ENV.isBeta && date.beta) {
    return new Date(date.beta)
  }

  return new Date(date.prod)
}

export function isFeatureActive(
  featureKey: TimeBasedFeatureKey,
  now: Date = new Date()
): boolean {
  const feature = TIME_BASED_FEATURES[featureKey]

  const startDate = resolveDate(feature.startDate)
  const endDate = resolveDate(feature.endDate)

  return now >= startDate && now <= endDate
}
